export default {
  attributes: {
    tmsId: {
      type: 'number',
      required: true,
    },
    modality: {
      type: 'string'
    },
    quote: {
      model: 'quote'
    },
    date: {
      type: 'ref',
      columnType: 'date',
      required: true,
    },
    consignee: {
      type: 'string',
      required: true,
    },
    shipper: {
      type: 'string',
      required: true,
    },
    notify: {
      type: 'string',
      allowNull: true,
    },
    availableAt: {
      columnType: 'date',

    },
    reference: {
      type: 'string',
      required: true,
    },
    hbl: {
      type: 'string',
      required: true,
    },
    mbl: {
      type: 'string',
      required: true,
    },
    goodsdescription: {
      type: 'string',
      required: true,
    },
    packages: {
      type: 'number',
      required: true,
    },
    weigth: {
      type: 'number',
      required: true,
    },
    vol: {
      type: 'number',
      required: true,
    },
    pol: {
      model: "portcatalog",
      required: true
    },
    pod: {
      model: "portcatalog",
      required: true
    },
    etd: {
      type: 'ref',
      columnType: 'date',
      required: true,
    },
    eta: {
      type: 'ref',
      columnType: 'date',
      required: true,
    },
    finaldestination: {
      type: 'string',
      required: true,
    },
    vessel: {
      model: "vesselcatalog",
      required: true,
    },
    voyage: {
      type: 'string',
      required: true,
    },
    carrier: {
      type: 'string',
      required: true,
    },
    atd: {
      type: 'ref',
      columnType: 'date',
      required: true,
    },
    ata: {
      type: 'ref',
      columnType: 'date',
      required: true,
    },
    containers:{
      collection:"containers",
      via:"arrivalnotification"
    },
    originalsNo:{
      type:'number',
    },
    payableBy:{
      type:'string'
    },
    payableAt:{
      type:'string'
    }
  },
};



// WEBPACK FOOTER //
// ./src/models/ArrivalNotification.js